import * as ReselectModule from "reselect";
import { IAssistancePersonListState } from ".";
import { IApplicationState } from "..";

export const selectAssistancePersonList: ReselectModule.Selector<
  IApplicationState,
  IAssistancePersonListState
> = (state) => state.assistancePersonList;
